import styled, { css } from 'styled-components';

import { mediaMixin, PageContent, spaceMixin, Spacer, token } from '@zillow/constellation';
import { SETTINGS } from '@zg-rentals/zrm-utils-js';

export const StyledMiddleFlex = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${spaceMixin('xs')};

  ${mediaMixin(
    'lg',
    css`
      justify-content: space-between;
      flex-grow: 1;
    `,
  )}
`;

export const StyledFlexContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  align-self: center;

  ${mediaMixin(
    'lg',
    css`
      flex-direction: row;
      align-items: center;
    `,
  )}
`;

export const StyledTagSpacer = styled(Spacer)`
  margin-bottom: 6px;

  ${mediaMixin(
    'lg',
    css`
      margin-bottom: 0px;
    `,
  )}
`;

export const StickyListingFooterContainer = styled.div<{
  isVisible?: boolean;
  isLayoutHorizontal: boolean;
}>`
  /*
     * if placeholder is visible, then changes back to fixed
     * else sticky
     */
  ${(props) =>
    props.isVisible
      ? css`
          position: static;
          box-shadow: 0;
        `
      : css`
          position: fixed;
          box-shadow:
            0 0 7px -2px rgba(0, 0, 0, 0),
            0 0 3px 0 rgba(0, 0, 0, 0.26);
        `}

  border-top: 1px solid ${token('colors.gray300')};
  bottom: 0;
  left: 0;
  width: 100%;
  background: ${token('colors.white')};
  z-index: 270;
  min-height: 114px;
  display: flex;

  padding: ${(props) => (props.isVisible ? '16px 0' : '16px 16px')};

  /* 481 */
  ${mediaMixin(
    'md',
    css`
      min-height: 0;
      height: 76px;
      padding: ${(props: { isVisible: boolean }) => (props.isVisible ? '16px 0' : '16px 24px')};
    `,
  )}

  /* 769 */
    ${mediaMixin(
    'lg',
    css`
      padding: ${(props: { isVisible: boolean }) => (props.isVisible ? '16px 0' : '16px 36px')};
    `,
  )}

  /* 1024 (breakpoint xl) */
  @media (min-width: ${SETTINGS.BREAKPOINTS_XL}px) {
    left: ${(props) => (props.isLayoutHorizontal && !props.isVisible ? `${SETTINGS.LEFT_NAV_WIDTH}px` : 0)};
    width: ${(props) =>
      props.isLayoutHorizontal && !props.isVisible ? `calc(100% - ${SETTINGS.LEFT_NAV_WIDTH}px)` : '100%'};
  }

  /* 1281 */
  ${mediaMixin(
    'xxl',
    css`
      padding: ${(props: { isVisible: boolean }) => (props.isVisible ? '16px 0' : '16px 24px')};
    `,
  )}
`;

export const StyledContainer = styled(PageContent)`
  && {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    padding: 0;
  }
`;
